import CourseSettingsError from './CourseSettingsError'
export default CourseSettingsError
